import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a round pedestal dining table, ~1.0 m diameter,
// top at 0.75 m, centred on the origin, base on y = 0.
const OAK = "#c8975a";
const MATTE_BLACK = "#2e2e30";

export const diningTableRound = defineModel({
  id: "dining-table-round",
  batchId: "modern",
  name: "Dining table (round)",
  tags: ["modern", "interior", "furniture", "dining", "table"],
  summary: "A round oak dining table on a matte-black pedestal base.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // oak top (top surface at 0.75)
      { geometry: new THREE.CylinderGeometry(0.5, 0.5, 0.05, 24), color: OAK, position: [0, 0.725, 0] },
      // pedestal column
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.62, 12), color: MATTE_BLACK, position: [0, 0.39, 0] },
      // spreader plate under the top
      { geometry: new THREE.CylinderGeometry(0.14, 0.14, 0.03, 16), color: MATTE_BLACK, position: [0, 0.685, 0] },
      // weighted base disc
      { geometry: new THREE.CylinderGeometry(0.2, 0.24, 0.08, 20), color: MATTE_BLACK, position: [0, 0.04, 0] },
    ];
  },
  animations: [],
});
